
const eGifts = [
  {
    path: "/",
    name: "E-Gift Voucher",
    component: () => import('@/components/Egifts/EgiftsListing'),
    props: true,
  },
    {
        path: ":slug",
        name: "e-gift/detail",
        component: () => import('@/components/Egifts/EgiftsDetail'),
        props: true,

      },
      {
        path: ":slug/payment",
        name: "e-gift/detail/payment",
        component: () => import('@/components/Egifts/Payments'),
        props: true,
      
      },
      {
        path: ":slug/payment/:paymentMethod/:response",
        name: "egift-payment-confirmation",
        component: () => import('@/components/Egifts/PaymentConfirmation'),
        props: true,
      },
  
   
  
  ];
  export default eGifts;
  